import React from 'react';
import { Input } from 'antd';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

export default function FormInput({ editable, name, value, error, onChange, layout, label, required, formItemClass, ...props }) {
  if (!editable) {
    return (
        <NotEditableItem title={props.placeholder} value={value} />
    );
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
      className={formItemClass}
    >
      <Input
        autoComplete="off"
        name={name}
        value={value}
        onChange={onChange}
        defaultValue=""
        {...props}
      />
    </FormItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/Input.js